module.exports = __webpack_public_path__ + "static/media/YB5M10_03.701564f3.jpg";